import React from 'react';
import * as GlobalVariables from '../config/GlobalVariableContext';
import { ButtonSolid, Link, ScreenContainer, withTheme } from '@draftbit/ui';
import * as WebBrowser from 'expo-web-browser';
import {
  KeyboardAvoidingView,
  StyleSheet,
  Text,
  TextInput,
  View,
} from 'react-native';

const HomeScreen = props => {
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;

  const { theme } = props;
  const { navigation } = props;

  const [SearchCriteria, setSearchCriteria] = React.useState('');

  return (
    <ScreenContainer scrollable={true} hasSafeArea={true}>
      <KeyboardAvoidingView
        style={styles.KeyboardAvoidingViewuz}
        enabled={true}
        behavior={'padding'}
      >
        <View
          style={[
            styles.Viewm1,
            { borderColor: theme.colors.medium, borderRadius: 0 },
          ]}
          pointerEvents={'auto'}
        >
          <View pointerEvents={'auto'} />
          <View style={styles.ViewLL} pointerEvents={'auto'}>
            <Text style={[styles.TextYh, { color: theme.colors.strong }]}>
              {
                "Welcome to Joanne Cooper's Band-in-a-Box files.\nFeel free to browse all the songs.\n New songs are added every week.\n Please read the instructions before continuing."
              }
            </Text>

            <View style={styles.Viewzc} pointerEvents={'auto'}>
              <Link
                onPress={() => {
                  try {
                    navigation.navigate('InstructionsScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[styles.LinkKd, { color: theme.colors.primary }]}
                title={'Click here to read the Instructions'}
              />
              <Text style={[styles.TextQ7, { color: theme.colors.strong }]}>
                {'Search for a song or artist'}
              </Text>
              <TextInput
                onChangeText={SearchCriteria => {
                  try {
                    setSearchCriteria(SearchCriteria);
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.TextInputEa,
                  { borderColor: theme.colors.strong },
                ]}
                placeholder={'Search Criteria'}
                value={SearchCriteria}
              />
              <ButtonSolid
                onPress={() => {
                  try {
                    navigation.navigate('SearchresultsScreen', {
                      SearchCriteria: SearchCriteria,
                    });
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolidgR,
                  { backgroundColor: theme.colors.primary },
                ]}
                title={'Search'}
              />
              <ButtonSolid
                onPress={async () => {
                  try {
                    await WebBrowser.openBrowserAsync(
                      'https://www.amazon.com/clouddrive/share/Bslp17OcAO6hegifjlMor2kmlKyAlvkNUCd23nJH1Vu'
                    );
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolidaG,
                  { backgroundColor: theme.colors.primary },
                ]}
                title={'Download Multiple SGU files'}
              />
            </View>

            <View style={styles.Viewuo} pointerEvents={'auto'}>
              <ButtonSolid
                onPress={() => {
                  try {
                    navigation.navigate('RecentlyAddedScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolid_6b,
                  { backgroundColor: theme.colors.error },
                ]}
                title={'Recent'}
              />
              <ButtonSolid
                onPress={() => {
                  try {
                    navigation.navigate('FeaturedScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolidQf,
                  { backgroundColor: theme.colors.error },
                ]}
                title={'Featured'}
              />
              <ButtonSolid
                onPress={() => {
                  try {
                    navigation.navigate('ChristmasScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolid_1G,
                  { backgroundColor: theme.colors.error },
                ]}
                title={'Holiday'}
              />
            </View>

            <View style={styles.Viewss} pointerEvents={'auto'}>
              <ButtonSolid
                onPress={() => {
                  try {
                    navigation.navigate('CountryScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolid_1n,
                  { backgroundColor: theme.colors.strong },
                ]}
                title={'Country'}
              />
              <ButtonSolid
                onPress={() => {
                  try {
                    navigation.navigate('FolkScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolidI8,
                  { backgroundColor: theme.colors.strong },
                ]}
                title={'Folk'}
              />
              <ButtonSolid
                onPress={() => {
                  try {
                    navigation.navigate('PopScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolid_6t,
                  { backgroundColor: theme.colors.strong },
                ]}
                title={'Pop'}
              />
              <ButtonSolid
                onPress={() => {
                  try {
                    navigation.navigate('RockScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolid_9Z,
                  { backgroundColor: theme.colors.strong },
                ]}
                title={'Rock'}
              />
            </View>

            <View style={styles.ViewXq} pointerEvents={'auto'}>
              <ButtonSolid
                onPress={() => {
                  try {
                    navigation.navigate('EasySongsScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolidjE,
                  { backgroundColor: theme.colors.strong },
                ]}
                title={'Easy songs'}
              />
              <ButtonSolid
                onPress={() => {
                  try {
                    navigation.navigate('NoBarChordsScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolid_8V,
                  { backgroundColor: theme.colors.strong },
                ]}
                title={'No bar chords'}
              />
              <ButtonSolid
                onPress={() => {
                  try {
                    navigation.navigate('ChordSongsScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolidIb,
                  { backgroundColor: theme.colors.strong },
                ]}
                title={'2 chord songs'}
              />
            </View>

            <View style={styles.Viewwo} pointerEvents={'auto'}>
              <ButtonSolid
                onPress={() => {
                  try {
                    navigation.navigate('ChordSongsScreen_NEbugIdk');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolidxz,
                  { backgroundColor: theme.colors.strong },
                ]}
                title={'3 chord songs'}
              />
              <ButtonSolid
                onPress={() => {
                  try {
                    navigation.navigate('ChordSongsScreen_6b7uaXmH');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolidJM,
                  { backgroundColor: theme.colors.strong },
                ]}
                title={'4 chord songs'}
              />
            </View>
          </View>
        </View>
      </KeyboardAvoidingView>
    </ScreenContainer>
  );
};

const styles = StyleSheet.create({
  TextYh: {
    marginTop: 10,
    textAlign: 'center',
    fontFamily: 'System',
    fontWeight: '700',
  },
  LinkKd: {
    textAlign: 'center',
    fontFamily: 'System',
    fontWeight: '700',
    marginBottom: 10,
    marginTop: 10,
    fontSize: 15,
    marginLeft: 10,
  },
  TextQ7: {
    marginBottom: 5,
    fontSize: 18,
    textAlign: 'left',
    marginLeft: 10,
  },
  TextInputEa: {
    borderLeftWidth: 3,
    borderRightWidth: 3,
    borderTopWidth: 3,
    borderBottomWidth: 3,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 8,
    paddingBottom: 8,
    borderRadius: 8,
    marginBottom: 5,
    marginLeft: 10,
    marginRight: 10,
    textAlign: 'center',
  },
  ButtonSolidgR: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginRight: 10,
    fontSize: 13,
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 10,
  },
  ButtonSolidaG: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 10,
  },
  Viewzc: {
    width: 300,
    alignContent: 'center',
    alignSelf: 'center',
  },
  ButtonSolid_6b: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginLeft: 5,
    marginRight: 5,
  },
  ButtonSolidQf: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginLeft: 5,
    marginRight: 5,
  },
  ButtonSolid_1G: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginLeft: 5,
    marginRight: 5,
  },
  Viewuo: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: 10,
    paddingBottom: 10,
  },
  ButtonSolid_1n: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginLeft: 5,
    marginRight: 5,
  },
  ButtonSolidI8: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginLeft: 5,
    marginRight: 5,
  },
  ButtonSolid_6t: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginLeft: 5,
    marginRight: 5,
  },
  ButtonSolid_9Z: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginLeft: 5,
    marginRight: 5,
  },
  Viewss: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: 10,
    paddingBottom: 10,
  },
  ButtonSolidjE: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginLeft: 5,
    marginRight: 5,
  },
  ButtonSolid_8V: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
  },
  ButtonSolidIb: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginLeft: 5,
    marginRight: 5,
  },
  ViewXq: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingTop: 10,
    paddingBottom: 10,
  },
  ButtonSolidxz: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginLeft: 5,
    marginRight: 5,
  },
  ButtonSolidJM: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginLeft: 5,
    marginRight: 5,
  },
  Viewwo: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: 10,
    paddingBottom: 10,
  },
  ViewLL: {
    flex: 1,
  },
  Viewm1: {
    alignItems: 'center',
    height: '70%',
    flex: 1,
    justifyContent: 'flex-end',
    marginBottom: 10,
    paddingBottom: 10,
    alignSelf: 'center',
  },
  KeyboardAvoidingViewuz: {
    flex: 1,
    justifyContent: 'space-around',
    paddingLeft: 10,
    paddingRight: 10,
  },
});

export default withTheme(HomeScreen);
